import { Record } from 'immutable';

import { formatCurrency } from 'utils/NumberHelper';

import {
  CreditScoreGrades,
  CreditScoreProviderLogo,
  CreditScoreProviderLogoUrl,
} from 'enums/credit-score-type';

const CreditReportRecord = Record({
  id: 0,
  companyDetails: null,
  creditScore: 0,
  creditScorePrevious: null,
  creditScoreGrade: '0',
  creditScoreText: '',
  creditScoreBand: '',
  creditLimit: 0,
  creditLimitPrevious: null,
  latestRatingChangeDate: null,
  creditEnquiries: null,
  creditLimitOverride: false,
  creditScoreOverride: false,
  probabilityOfDefault: 0,
  providerName: '',
  provider: '',
  riskFactors: null,
  riskFactorsSummary: null,
  filingHistory: {},
  legalNotices: null,
  paymentPerformance: null,
  ccjs: null,
  windUp: null,
});

export default class CreditReport extends CreditReportRecord {
  static deserialize(jsonObject = {}) {
    return new CreditReport(jsonObject);
  }

  get logo() {
    return CreditScoreProviderLogo[this.providerName];
  }

  get logoUrl() {
    return CreditScoreProviderLogoUrl[this.providerName];
  }

  get isGoodScore() {
    return CreditScoreGrades.good.includes(this.creditScoreGrade);
  }

  get isMediumScore() {
    return CreditScoreGrades.medium.includes(this.creditScoreGrade);
  }

  get isPoorScore() {
    return CreditScoreGrades.poor.includes(this.creditScoreGrade);
  }

  get limit() {
    return this.creditLimit ? formatCurrency(this.creditLimit) : 'N/A';
  }
}
